import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css';
import './colors.css';
import './rtl.css'; // RTL CSS support
import GlobalFont from './GlobalFont';
import './i18n'; 
import { performCountryRedirectIfNeeded } from './hooks/useCountryRedirect';
import ApiService from './services/api';

const root = ReactDOM.createRoot(document.getElementById('root')!);

const renderBootstrapLoader = () => {
  root.render(
    <React.StrictMode>
      <GlobalFont />
      <style>{`
        @keyframes app-bootstrap-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#ffffff',
        }}
      >
        <div
          style={{
            width: '42px',
            height: '42px',
            borderRadius: '50%',
            border: '4px solid #e6e6e6',
            borderTopColor: '#2f2f2f',
            animation: 'app-bootstrap-spin 0.8s linear infinite',
          }}
          aria-label="Loading"
          role="status"
        />
      </div>
    </React.StrictMode>,
  );
};

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <GlobalFont />
      <App />
    </React.StrictMode>,
  );
};

const bootstrap = async () => {
  renderBootstrapLoader();

  try {
    await new ApiService().getCountryNameFromIp();
  } catch {
    // continue if geo lookup fails
  }

  const redirected = await performCountryRedirectIfNeeded();

  // If redirected, browser will navigate away; no need to render this app.
  if (redirected) return;

  renderApp();
};

void bootstrap();